module.exports = __webpack_public_path__ + "static/img/xk100.45cea11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xk100.jpg
// module id = BQuZ
// module chunks = 19